import { fn, hash } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { t } from 'ember-intl';
import { not } from 'ember-truth-helpers';

import Button from 'umg-ember-backend/components/ui/button';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import Form from './form';
import SelectedInfo from './selected-info';
import styles from './styles.module.css';

const bem = getBem(styles);

export default class PageBuilderOptions extends Component {
  // Services
  @service flashMessages;
  @service history;
  @service permission;
  @service pageBuilderFrontendApi;
  @service recordStatus;

  // Getter and setter
  get isMlpDisabled() {
    return this.recordStatus.isDisabled(this.args.mlp);
  }

  // Actions
  resetOptions = async (model) => {
    let ok = await this.history.confirmAction('resetOptions', model);

    if (!ok) {
      return;
    }

    try {
      await model.resetOptions();
      this.flashMessages.success('flash.resetOptions.success');
    } catch (error) {
      this.flashMessages.serverError(error);
    }
  };

  // Template
  <template>
    {{#if @selectedModelToStyle}}
      <div class={{(bem)}}>
        {{#if @mlp.pages.length}}
          <div class={{bem 'select'}}>
            <div
              role='button'
              class={{bem 'option' (hash is-selected=@isMlpSelected)}}
              {{on 'click' (fn (mut @isMlpSelected) true)}}
            >
              {{t 'page_builder.options.global'}}
            </div>
            <div
              role='button'
              class={{bem 'option' (hash is-selected=(not @isMlpSelected))}}
              {{on 'click' (fn (mut @isMlpSelected) false)}}
            >
              {{t 'page_builder.options.selected'}}
            </div>
          </div>
        {{/if}}
        <SelectedInfo
          @selectedModelToStyle={{@selectedModelToStyle}}
          @mlp={{@mlp}}
        />

        <Form
          @loadLegalContext={{@loadLegalContext}}
          @model={{@selectedModelToStyle}}
          @showErrors={{@showErrors}}
          @mlp={{@mlp}}
        />

        <div class={{bem 'actions'}}>
          {{#if this.permission.user.isAdmin}}
            <Button
              @displayBlock={{true}}
              @disabled={{this.isMlpDisabled}}
              @label={{t 'page_builder.options.reset'}}
              @style='danger'
              {{on 'click' (fn this.resetOptions @selectedModelToStyle)}}
            />
            <Button
              @displayBlock={{true}}
              @label={{if
                this.pageBuilderFrontendApi.useLocalhost
                (t 'page_builder.options.use_production_api')
                (t 'page_builder.options.use_localhost_api')
              }}
              @style={{if
                this.pageBuilderFrontendApi.useLocalhost
                'active'
                'grey'
              }}
              {{on 'click' this.pageBuilderFrontendApi.togglePageBuilderApi}}
            />
          {{/if}}
        </div>
      </div>
    {{/if}}
  </template>
}
